import React, { useEffect, useState } from 'react';
import {
  FormControl, InputLabel, Select, MenuItem, TextField, Tooltip,
} from '@mui/material';
import EmployeeSearch from '../../common/EmployeeSearch';
import { sectionOptionLabel } from '../../../utils/ingestionSyncRuns';
import { FilterBar } from './styles';

const SEARCH_DEBOUNCE_MS = 400;

const ItemsFilterBar = ({ sections, section, employee, q, onChange }) => {
  const [searchText, setSearchText] = useState(q || '');

  useEffect(() => {
    setSearchText(q || '');
  }, [q]);

  useEffect(() => {
    if ((searchText || '') === (q || '')) {
      return undefined;
    }
    const timer = setTimeout(() => onChange({ q: searchText }), SEARCH_DEBOUNCE_MS);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText]);

  return (
    <FilterBar>
      <FormControl size="small" sx={{ minWidth: 280 }}>
        <InputLabel id="isr-section-label">Section</InputLabel>
        <Select
          labelId="isr-section-label"
          label="Section"
          value={section || ''}
          onChange={(event) => onChange({ section: event.target.value })}
        >
          {sections.map((option) => (
            <MenuItem key={option.sectionKey} value={option.sectionKey} disabled={option.hidden}>
              {option.hidden ? (
                <Tooltip arrow placement="right" title="Stored for this run, but too large to list in the UI">
                  <span>{sectionOptionLabel(option)}</span>
                </Tooltip>
              ) : sectionOptionLabel(option)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        size="small"
        label="Search"
        placeholder="Name, email or source id"
        value={searchText}
        onChange={(event) => setSearchText(event.target.value)}
        sx={{ minWidth: 220 }}
      />

      <EmployeeSearch
        value={employee || null}
        onChange={(next) => onChange({ employee: next || null })}
        label="Individual"
        placeholder="Search individuals…"
        width="100%"
        height="40px"
        showSelectedAvatar
        sx={{ minWidth: 220, flex: 1 }}
      />
    </FilterBar>
  );
};

export default ItemsFilterBar;
